// Three.js r183 deprecated `THREE.Clock` in favour of `THREE.Timer`, but
// @react-three/fiber still constructs `new THREE.Clock()` internally for its
// render loop (events-*.esm.js). Until R3F upstreams the migration, every
// Canvas mount fires a noisy `THREE.Clock: This module has been deprecated...`
// warning. Filter that one specific message so the DevTools console stays
// useful — keep all other Three / R3F warnings intact.
//
// Remove this filter once @react-three/fiber switches to `THREE.Timer`.

const CLOCK_DEPRECATION_RE = /THREE\.Clock: This module has been deprecated/;

const originalWarn = console.warn.bind(console);

console.warn = (...args: unknown[]) => {
  const first = args[0];
  if (typeof first === 'string' && CLOCK_DEPRECATION_RE.test(first)) return;
  originalWarn(...args);
};
